// extracted by mini-css-extract-plugin
module.exports = {"GridContainer":"Scratchpad_GridContainer__Cusru","Link":"Scratchpad_Link__2QMiR"};